import {Component, Inject, OnInit} from '@angular/core';
import {Localiser} from "../../../services/localiser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {proyecto} from "../../../models/proyecto";

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.css']
})
export class WarningComponent implements OnInit {

  proyecto: proyecto;

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<WarningComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {proyecto: proyecto}) { }

  ngOnInit(): void {
    console.log(this.data)
    this.proyecto = this.data.proyecto;
    console.log(this.proyecto)
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onStartClick(): void {
    this.dialogRef.close(true);
  }

}
